function hideTable(){
	var $table = $('.where-table'),
			$tableMobile = $('.where-table--mobile');

	var hide = function(){
		if ($(window).outerWidth() < 768) {
			$table.not($tableMobile).hide();
		}else{
			$table.show();
		}
	}
	hide();

	$(window).resize(function(){
		hide();
	})
}
hideTable();